export const SET_VOUCHER_COOKIES = 'SET_VOUCHER_COOKIES'

export function setVoucherCookies(voucherCookies) {
  return {
    type: SET_VOUCHER_COOKIES,
    voucherCookies,
  }
}

export const SET_GIF_CERTIFICATE_COOKIES = 'SET_GIF_CERTIFICATE_COOKIES'

export function setGifCertificateCookies(payload) {
  return {
    type: SET_GIF_CERTIFICATE_COOKIES,
    payload,
  }
}

export const SET_MEMBER_COOKIES = 'SET_MEMBER_COOKIES'

export function setMemberCookies(memberCookies) {
  return {
    type: SET_MEMBER_COOKIES,
    memberCookies,
  }
}

export const SET_TICKET_COOKIES = 'SET_TICKET_COOKIES'

export function setTicketCookies(ticketCookies) {
  return {
    type: SET_TICKET_COOKIES,
    ticketCookies,
  }
}

export const SET_LISTING_COOKIES = 'SET_LISTING_COOKIES'

export function setListingCookies(listingCookies) {
  return {
    type: SET_LISTING_COOKIES,
    listingCookies,
  }
}

export const SET_MEMBER_PROFILE_COOKIES = 'SET_MEMBER_PROFILE_COOKIES'

export function setMemberProfileCookies(memberProfileCookies) {
  return {
    type: SET_MEMBER_PROFILE_COOKIES,
    memberProfileCookies,
  }
}

export const SET_NOTIFICATION_COOKIES = 'SET_NOTIFICATION_COOKIES'

export function setNotificationCookies(notificationCookies) {
  return {
    type: SET_NOTIFICATION_COOKIES,
    notificationCookies,
  }
}

export const SET_OTHERLOCATIONS_COOKIES = 'SET_OTHERLOCATIONS_COOKIES'

export function setOtherLocationsCookies(otherLocationsCookies) {
  return {
    type: SET_OTHERLOCATIONS_COOKIES,
    otherLocationsCookies,
  }
}

export const SET_GAME_COOKIES = 'SET_GAME_COOKIES'

export function setGameCookies(payload) {
  return {
    type: SET_GAME_COOKIES,
    payload,
  }
}

export const SET_POS_PROMO_COOKIES = 'SET_POS_PROMO_COOKIES'

export function setPosPromoCookies(payload) {
  return {
    type: SET_POS_PROMO_COOKIES,
    payload,
  }
}
